import {Link, useLocation, useMatches} from '@remix-run/react';
import {blogPageHref} from '~/lib/blogPagination';

/** Real page links keep every post reachable without JavaScript or scrolling. */
export default function BlogListingFetch({
  page,
  pageCount,
}: {
  page: number;
  pageCount: number;
}) {
  const {pathname} = useLocation();
  const [root] = useMatches();
  const english = root.data?.selectedLocale?.language === 'EN';
  if (pageCount <= 1) return null;

  const visiblePages = Array.from({length: pageCount}, (_, i) => i + 1).filter(
    (n) => n === 1 || n === pageCount || Math.abs(n - page) <= 2,
  );

  return (
    <nav
      className="my-10 flex flex-wrap items-center justify-center gap-3"
      aria-label={english ? 'Blog pages' : '網誌分頁'}
    >
      {page > 1 && (
        <Link
          rel="prev"
          to={blogPageHref(pathname, page - 1)}
          className="px-2 py-3 hover:underline"
        >
          {english ? 'Previous' : '上一頁'}
        </Link>
      )}
      {visiblePages.map((n, i) => (
        <span key={n} className="flex items-center gap-3">
          {i > 0 && n > visiblePages[i - 1] + 1 && (
            <span aria-hidden="true">…</span>
          )}
          <Link
            to={blogPageHref(pathname, n)}
            aria-current={page === n ? 'page' : undefined}
            aria-label={english ? `Page ${n}` : `第 ${n} 頁`}
            className={`rounded-sm border px-4 py-3 ${
              page === n
                ? 'border-hk-orange bg-hk-orange'
                : 'border-gray-300 hover:border-hk-orange'
            }`}
          >
            {n}
          </Link>
        </span>
      ))}
      {page < pageCount && (
        <Link
          rel="next"
          to={blogPageHref(pathname, page + 1)}
          className="px-2 py-3 hover:underline"
        >
          {english ? 'Next' : '下一頁'}
        </Link>
      )}
    </nav>
  );
}
